import { createContext, useContext } from "react";

import type { ProductDummyRoomFormModel } from "../../../model/type";

type QueryData = ProductDummyRoomFormModel["QueryData"];
type ViewModel = ProductDummyRoomFormModel["ViewModel"];

export type ProductDummyRoomFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;
};

export const ProductDummyRoomFormModelContext = createContext<ProductDummyRoomFormModelContextType | null>(null);

export const useProductDummyRoomFormModelContext = () => {
	const context = useContext(ProductDummyRoomFormModelContext);

	if (!context) {
		throw new Error(
			"useProductDummyRoomFormModelContext must be used within a ProductDummyRoomFormModelContext.Provider",
		);
	}

	return context;
};
